import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  allTransactions: [],
  transactions: [],
  transaction: false,
  loading: false,
  formLoading: false,
  exportLoading: false,
  exportSuccess: false,
  error: false,
  success: false,
  preventNew: false,
  paging: false,
  downloadLink: '',
  accountsWithTotal: false,
  transactionsCreated: 0,
  coownerUser: false,
  transactionUser: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Transactions/index.js